import Service from "./apiService";

class PushNotificationsService extends Service {
  getData() {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `push_notifications`,
      method: "GET",
    });
  }

  get(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `push_notifications/${id}`,
      method: "GET",
    });
  }  

  add(form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `push_notifications`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  update(id, form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `push_notifications/${id}`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  delete(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `push_notifications/${id}`,
      method: "DELETE",
    });
  }

  sendTest(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `push_notifications/${id}/send_test`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    });
  }

  send(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `push_notifications/${id}/send`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    });
  }

}

export var pushNotificationsService = new PushNotificationsService();
